import { createAction } from 'redux-actions'
import { types } from 'features/session/store/types'
import _get from 'lodash/get'
import { openPopup } from 'features/popup/store/actions'
import { handleAPIError } from 'features/app/store/actions'
import { translations } from 'gipsy-misc'
import inject from 'utils/inject'
import { calendar } from 'gipsy-api'
import RealTimeClient from 'features/realTimeClient'

import moment from 'moment'

export const remove = createAction(types.REMOVE_SESSION)
/* set the whole user object (set with GET session or GET User action) */
export const setUser = createAction(types.SET_USER)
/* set the whole weeklyWorkingHours object (set with GET session) */
export const setWeeklyWorkingHours = createAction(types.SET_WEEKLY_WORKING_HOURS)

export const _set = createAction(types.SET_SESSION)
export const set = user => async (dispatch, getState, { api }) => {
  inject('gipsy-ui', 'user', user)
  inject('gipsy-misc', 'user', user)
  dispatch(_set(user))
}

export const get = () => async (dispatch, getState, { api }) => {
  try {
    const tz = moment.tz.guess()
    const session = await api.session.get(tz)

    try {
      await RealTimeClient.init(session.user.id)
    } catch (err) {
      console.error(err)
    }
    dispatch(set(session.user))
    if (session.code && _get(translations, `message.success.${session.code}`)) {
      dispatch(
        openPopup(
          {
            message: _get(translations, `message.success.${session.code}`),
            button: translations.general.ok.toUpperCase(),
            action: 'onClose'
          },
          15 * 1000
        )
      )
    }

    if (session.user.emails) {
      for (let email of session.user.emails) {
        try {
          calendar.synchronize(email)
        } catch (err) {
          dispatch(handleAPIError(err))
        }
      }
    }
  } catch (err) {
    dispatch(remove())
  }
}

export const getUser = () => async (dispatch, getState, { api }) => {
  try {
    const user = await api.user.get()
    dispatch(setUser(user))
  } catch (err) {
    dispatch(handleAPIError(err))
  }
}

export const signout = () => async (dispatch, getState, { api }) => {
  api.session.signout()
  dispatch(remove())
}



// WEBPACK FOOTER //
// ./src/features/session/store/actions.js